import {TeamMembersIcon as Users,PersonalAvailabilityIcon as UserRound,NotificationIcon as Bell} from '../icons/AppIcons';
import React from 'react';

import EventLinkedItems from '../planning/EventLinkedItems';
import {eventTagLabel} from '../../utils/eventSetup';

export default function CalendarEventCard({event, teamId, source, start, end}) {
  const duration = (end - start) / 60000;
  const format = date => date.toLocaleTimeString(undefined,{hour:'2-digit',minute:'2-digit',hourCycle:'h23'});
  const SourceIcon = event.calendar === 'team' ? Users : UserRound;
  return <div className={`calendar-event-card ${duration < 90 ? 'calendar-event-card--compact' : ''} ${duration <= 45 ? 'calendar-event-card--short' : ''}`}
    title={`${event.note || eventTagLabel(event)} · ${format(start)}–${format(end)} · ${source} · Created by ${event.createdBy || 'Unknown'}`}>
    <div className="calendar-event-card__source"><span className={`event-source-pill ${event.calendar === 'team' ? 'team' : 'personal'}`}>{source}</span><SourceIcon size={12} aria-hidden="true"/></div>
    <div className="event-content"><strong className="event-note-truncated">{event.note || eventTagLabel(event)}</strong><EventLinkedItems event={event} teamId={event.__teamId || teamId}/></div>
    <span className="calendar-event-card__time">{format(start)} – {format(end)}</span>
    <div className="calendar-event-card__details"><span className="calendar-event-card__tag">{eventTagLabel(event)}</span>
      {Array.isArray(event.participants) && event.participants.length > 0 && <span title={event.participants.join(', ')}><Users size={11} aria-hidden="true"/>{event.participants.length}</span>}
      {event.reminder && <span title="Reminder"><Bell size={11} aria-hidden="true"/></span>}
    </div>
  </div>;
}
